// The free journal template's files and tabs, shared by TemplatePage.js and prerender.js.
export const TEMPLATE_FILES = {
  en: '/templates/market-matrix-trading-journal-template.xlsx',
  es: '/templates/market-matrix-plantilla-diario-de-trading.xlsx',
};

// What's inside, tab by tab.
export const TEMPLATE_TABS = [
  ['Trades', 'One row per trade. Pick the symbol and side from lists; points, gross P&L and net P&L after fees fill in by themselves for ES, MES, NQ, MNQ, YM, MYM, RTY, M2K, CL, MCL, GC and MGC.'],
  ['Daily review', 'One row per day: your daily P&L and trade count fill in, then you note whether you followed your plan, your mood, what went well and what to fix.'],
  ['Summary', 'Win rate, profit factor, average win and loss, best and worst day, what each setup makes and what each mistake costs you.'],
  ['Account rules', 'Enter your starting balance, profit target, max loss and daily limit to see how far you are from passing and from your limits.'],
  ['Lists', 'Your own setups and mistakes, used by the dropdowns on the Trades tab.'],
];
